import React from "react";
import Backdrop from "@mui/material/Backdrop";
import "./styles.css";
import { CircularProgress } from "@mui/material";

const FullScreenLoader = ({ open = false }) => {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 999 }}
      open={open}
    >
      <CircularProgress color="warning" />
    </Backdrop>
  );
};

export default FullScreenLoader;
